import React, { Component } from 'react';
import { connect } from 'react-redux';
import dropin from 'braintree-web-drop-in';

import actions from '../../redux/actions';
import actionTypes from '../../redux/actionTypes';
import Heading from '../Heading';
import NavButtons from '../NavButtons';
import {
  getSubscriptionTypeForCreg,
} from '../../utils';
import {
  // COST_COSYND_ADMIN_FEE,
  TIER_2M,
  TIER_3M,
  TIER_1A,
  FEDERAL_FILLING_FEE_A,
  FEDERAL_FILLING_FEE_M,
  TIER_1M,
} from '../../constants';

class PublicationPayment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      instance: null,
      cart: null,
      payLoading: false,
      fee: 0,
    };
  }

  componentWillMount() {
    const { fields } = this.props;

    if (!fields.type || fields.type === '') {
      this.props.router.push('/');
    } else {
      this.props.getClientToken();
      this.calculate();
    }
  }

  componentWillReceiveProps(nextProps) {
    const { status, cregStatus } = nextProps;

    if (cregStatus !== this.props.cregStatus) {
      if (cregStatus === actionTypes.COREG_CREATE_SUCCESS) {
        this.setState({ payLoading: false }, () => {
          this.props.loadProfile();
          this.props.router.push('/publication-reg/complete');
        });
      } else if (cregStatus === actionTypes.COREG_CREATE_ERROR) {
        this.setState({ payLoading: false });
        this.props.alert('error', 'Copyright create failed. Please try again');
      }
    }

    if (status !== this.props.status) {
      if (status === actionTypes.PAYMENT_TRANSACTION_SUCCESS) {
        this.props.changeCart({ simple: 0, standard: 0 });
        this.createCoreg();
      } else if (status === actionTypes.PAYMENT_TRANSACTION_ERROR) {
        this.setState({ payLoading: false });
        this.props.alert('error', 'Payment failed. Please try again');
      }
    } else {
      this.calculate();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { clientToken } = this.props;
    const { instance } = this.state;

    if (clientToken && !instance) {
      dropin.create(
        {
          authorization: clientToken,
          container: '#dropin-container',
          translations: {
            chooseAWayToPay: 'Choose a payment option below:',
          },
        },
        (err, instance) => {
          if (!err) {
            this.setState({ instance });
          }
        }
      );
    }
  }

  createCoreg() {
    const { fields, profile, coregTemp, subscription } = this.props;

    const { planType } = getSubscriptionTypeForCreg(
      profile.subscription_plan,
      subscription
    );

    const coreg = {
      user: profile.id,
      data: JSON.stringify(fields),
      is_success: false,
      tempId: coregTemp ? coregTemp.id : null,
      planType,
    };
    this.props.createCoreg(coreg);
  }

  getFederalFee = (cart) => {
    const { profile, subscription } = this.props;
    const { planType } = getSubscriptionTypeForCreg(
      profile.subscription_plan,
      subscription
    );
    let federalFee = 0;

    if (planType === 'free') {
      federalFee = FEDERAL_FILLING_FEE_A;
    } else {
      federalFee = FEDERAL_FILLING_FEE_M;
    }

    return federalFee;
  };

  calculate() {
    let {
      fields,
      // profile,
      cart: { simple },
    } = this.props;

    // console.log(this.props);

    if (fields.titleTypes && fields.publishInfo.url) {
      const fee = this.getAdminFee();
      const federaFee =  this.getFederalFee();
      const total = fee + federaFee;

      this.setState({
        cart: {
          simple,
          standard: 1,
          total: total,
        },
        fee,
      });
    }
  }

  getAdminFee = () => {
    const { profile, subscription } = this.props;
    const { planType } = getSubscriptionTypeForCreg(
      profile.subscription_plan,
      subscription
    );
    let adminFee = 0;
    // const cregCount = parseInt(profile.creg_count, 10);

    if (planType === 'tier_1m') {
      adminFee = TIER_1M;
    } else if (planType === 'tier_2m') {
      adminFee = TIER_2M;
    } else if (planType === 'tier_3m') {
      adminFee = TIER_3M;
    } else {
      adminFee = TIER_1A;
    }

    return adminFee;
  };

  handlePayment = () => {
    const { instance, cart, fee } = this.state;

    // Process purchase and create transaction
    this.props.hideAlert();

    if (instance && cart.total) {
      this.setState({ payLoading: true }, () => {
        this.props.alert(
          'info',
          'Payment is processing, please do not refresh page.'
        );
      });

      instance.requestPaymentMethod((err, payload) => {
        if (err) {
          console.error(err);
          this.setState({ payLoading: false });
          this.props.alert('error', 'Payment creation failed.');
        } else {
          const data = {
            nonce: payload.nonce,
            amount: cart.total.toString(),
            admin_fee_total: fee,
          };
          this.props.pay(data);
        }
      });
    }
  };

  handleNext() {
    const { status } = this.props;

    this.props.hideAlert();

    if (status !== actionTypes.PAYMENT_TRANSACTION_SUCCESS) {
      this.props.alert('error', 'Please make a valid payment.');
    }
  }

  discountedPremiumUser = () => {
    const { profile, subscription } = this.props;
    const { planType } = getSubscriptionTypeForCreg(
      profile.subscription_plan,
      subscription
    );
    // const cregCount = parseInt(profile.creg_count, 10);

    // if (planType === 'premium' && cregCount < CREG_LIMIT_FOR_PREMIUM_ANNUAL) {
    if (planType === 'premium' && profile.referrer) {
      return true;
    }
    return false;
  };

  trialReferrerUser = () => {
    const { profile, subscription } = this.props;
    const { planType } = getSubscriptionTypeForCreg(
      profile.subscription_plan,
      subscription
    );

    if (planType !== 'premium' && profile.referrer) {
      return true;
    }
    return false;
  };

  renderCart() {
    const { cart } = this.state;

    if (!cart) return null;

    return (
      <div className="cart">
        <p>
          <strong>
            Please review your order below. If you leave this session without
            completing this step, your information will not be saved and your
            order will not be processed.
          </strong>
        </p>
        <ul>
          {cart.simple > 0 && (
            <li>
              Federal Filing Fee (${this.getFederalFee(cart)}) x {cart.simple}
              <br />
              {/* Simple Application (${this.getFederalFee(cart)}) x {cart.simple}<br /> */}
              {/* <i>- An application containing 1 work by 1 author.</i> */}
            </li>
          )}
          {cart.standard > 0 && (
            <li>
              Federal Filing Fee (${this.getFederalFee(cart)}) x {cart.standard}
              <br />
              {/* Standard Application (${this.getFederalFee(cart)}) x {cart.standard}<br />
                            <i>- An application containing multiple works by multiple authors.</i> */}
            </li>
          )}
          <li>
            Cosynd Administrative Fee (
            <span
              className={`standard-fee ${
                this.trialReferrerUser() || this.discountedPremiumUser()
                  ? 'removed-fee'
                  : ''
              }`}
            >
              ${TIER_1A}
            </span>
            {this.trialReferrerUser() && (
              <span className="discount-fee">&nbsp;${this.getAdminFee()}</span>
            )}
            {!this.trialReferrerUser() && this.discountedPremiumUser() && (
              <span className="discount-fee">&nbsp;${this.getAdminFee()}</span>
            )}
            {/* {this.discountedPremiumUser() && <span className="discount-fee">&nbsp;$0</span>} */}
            ) x {cart.standard + cart.simple}
          </li>
        </ul>
        <p>
          <strong>
            Cart Total: <span className="pl4 text-green">${cart.total}</span>
          </strong>
        </p>
      </div>
    );
  }

  render() {
    const { payLoading } = this.state;

    return (
      <div className="complete-pay">
        <Heading text="Review and Checkout" />
        <div className="content">
          <div className="inner">
            {this.renderCart()}
            <div id="dropin-container"></div>
            <div className="payment-action">
              <button
                id="payment-button"
                disabled={payLoading}
                onClick={this.handlePayment}
              >
                {payLoading ? 'Processing...' : 'Pay Now'}
              </button>
            </div>
          </div>
        </div>
        <div className="step-nav">
          <NavButtons
            direction="back"
            prev={() => this.props.router.goBack()}
          />
          <NavButtons direction="next" next={() => this.handleNext()} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  profile: state.profile,
  fields: state.coreg.fields,
  coregTemp: state.coreg.coregTemp,
  cart: state.coreg.cart,
  clientToken: state.payment.clientToken,
  status: state.payment.status,
  cregStatus: state.coreg.status,
  subscription: state.payment.subscription,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  assignAttribute: (field, attribute) => {
    dispatch(actions.assignCoregAttribute(field, attribute));
  },
  getClientToken: () => {
    dispatch(actions.clientToken());
  },
  pay: (options) => {
    dispatch(actions.pay(options));
  },
  changeCart: (cart) => {
    dispatch(actions.changeCart(cart));
  },
  createCoreg: (coreg) => {
    dispatch(actions.createCoreg(coreg));
  },
  loadProfile: () => {
    dispatch(actions.getProfile());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PublicationPayment);



// WEBPACK FOOTER //
// src/components/Publication/PublicationPayment.jsx